import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatDatepickerModule, MAT_DATE_LOCALE,
  MatSelectModule, MatFormFieldModule, MatNativeDateModule, MatInputModule
} from '@angular/material';
import { TranslateModule } from '../../../../shared/translate/translate.module';
import { MedicationRequestAddComponent } from './medication-request-add.component';

@NgModule({
  declarations: [MedicationRequestAddComponent],
  imports: [
    CommonModule, IonicModule, FormsModule, ReactiveFormsModule,
    MatDatepickerModule,
    MatSelectModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatInputModule,
    TranslateModule],
  providers: [
    MatDatepickerModule,
    { provide: MAT_DATE_LOCALE, useValue: 'hu-HU' }
  ],
  exports: [MedicationRequestAddComponent]
})
export class MedicationRequestAddModule { }
